import * as tslib_1 from "tslib";
import { CHANNEL } from '../../../../constants/channel.constants';
import { BaseChannelCommunicatorService } from '../base-channel-communicator.service';
var PortalOperadorImplService = /** @class */ (function (_super) {
    tslib_1.__extends(PortalOperadorImplService, _super);
    /**
     * Constructor de la clase
     *
     * *Class Contstructor.*
     *
     * Inicializa los métodos para los modelos
     *
     * *Initialize method for models*
     *
     * @function initService
     */
    function PortalOperadorImplService() {
        var _this = _super.call(this) || this;
        // tslint:enable:one-line
        _this.CHANNEL_ID = CHANNEL.PORTALO.CODE;
        _this.initService(true);
        return _this;
    }
    /**
     * Creación de la promesa para la comunicación con portalpn
     *
     * *Promise creation for portalpn communication*
     *
     * @param {string} op
     */
    PortalOperadorImplService.prototype.createPromise = function (op) {
        return new Promise(function (resolve, _reject) {
            var callback = function (event) {
                console.log(event.data, 'dato');
                if (event.data.origin !== CHANNEL.PORTALO.NAME ||
                    event.data.op !== op) {
                    return;
                }
                resolve(event.data);
                window.removeEventListener('message', callback);
            };
            window.addEventListener('message', callback);
        });
    };
    /**
     * Llamada a una función Nativa dependiendo del canal
     *
     * *Calls native function depending on the channel*
     *
     * @param {ExternalRequest} request
     */
    PortalOperadorImplService.prototype.postMessageToChannel = function (request) {
        window.parent.postMessage(request, window.location.origin);
    };
    return PortalOperadorImplService;
}(BaseChannelCommunicatorService));
export { PortalOperadorImplService };
